import { iconFor, slugFor } from './tarotIcons.js';

// GuideContentService builds role.tarotCards as a fixed triple:
// [ViewedAlignmentCard, KillingCard, WitchcraftCard]. The explicit fields are
// preferred when present so a badge never depends on array position.
const meanings = ['Alignment', 'Killing', 'Witchcraft'];

// Slot 2 (Death/Dove) and slot 3 (Magician/Labourer) reuse card names that slot 1 also
// draws from the alignment map, so a card name alone does not say which axis it is
// on. These prefix the visible chip so two chips never read as the same fact.
const shortLabels = ['Seen', 'Kills', 'Magic'];

function cardsFor(role) {
    const explicit = [role.viewedAlignmentCard, role.killingCard, role.witchcraftCard];
    if (explicit.some((card) => card)) return explicit;
    return role.tarotCards || [];
}

// Shape shared with itemBadges.js and auraBadges.js so BadgeRow renders all three. Role
// badges carry no facet: a tarot card is what a check reports, and the alignment, killing
// and witchcraft facets are already reachable from the filter bar.
export function badgesFor(role) {
    if (!role) return [];

    return cardsFor(role)
        .map((card, index) => ({
            label: card,
            meaning: meanings[index] || 'Tarot',
            shortLabel: shortLabels[index] || 'Card',
            icon: iconFor(card),
            slug: slugFor(card),
        }))
        .filter((badge) => badge.label);
}

export default badgesFor;
